export default {
  name: '',
  address: '',
  photoImageUrl: '',
}
